export enum Icons {
  'mini-cart' = '',
  'ready' = '',
  'customer-support' = '',
  'total_orders' = '',
  'order_progress' = '',
  'awaiting_orders' = '',
  'icon_eco_van_green' = '',
  'icon_eco_van_white' = '',
  'icon_eco_van_sm' = '',
  'icon_eco_van_mm' = '',
}
